import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H2Props extends ComponentPropsWithRef<"h2"> {
  blockPath: string;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const H2 = forwardRef<HTMLHeadingElement, H2Props>(
  ({ text, blockPath, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h2
        ref={ref}
        className={classNames(
          "wb-text-h2-color wb-text-h2 wb-font-h2 wb-leading-h2 wb-tracking-h2 wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h2>
    );
  },
);

H2.displayName = "H2";
